import {
  BriefcaseBusiness,
  CarFront,
  Dumbbell,
  GraduationCap,
  HeartPulse,
  Hotel,
  House,
  Scissors,
  Store,
  Utensils,
  Wrench,
} from 'lucide-react';

const common = {
  proof: {
    quote: null,
    author: null,
    role: null,
  },
};

export const VERTICALS = [
  {
    ...common,
    id: 'beauty',
    label: 'Belleza',
    shortLabel: 'Belleza',
    icon: Scissors,
    theme: { accent: '#EC4899', accent2: '#F9A8D4', ink: '#3B102B', surface: '#FFF1F7', glow: '#FCE7F3' },
    eyebrow: 'Para salones, spas, barberías y estudios',
    problem: 'Tu agenda se ve llena, pero una cancelación de último minuto deja una silla vacía y dinero sobre la mesa.',
    agitation: 'Entre DMs, WhatsApp y llamadas, confirmar citas, recordar retoques y recuperar clientas depende de la memoria de alguien. Y la memoria también pide vacaciones.',
    solution: 'CavernicolApp reúne conversaciones, agenda y seguimiento para confirmar, reasignar espacios y provocar la siguiente visita desde un solo lugar.',
    job: 'Mantener cada cabina y especialista ocupados sin perseguir citas conversación por conversación.',
    outcome: 'Más continuidad entre la primera consulta, la cita y la recompra.',
    alert: 'Color y corte · confirmado',
    resource: 'Estación 03 · Andrea',
    lead: 'Mariana preguntó por balayage',
    nextAction: 'Enviar opciones y reservar',
    benefits: [
      ['Agenda que vende', 'Confirma citas, organiza especialistas y detecta huecos antes de que se conviertan en horas perdidas.'],
      ['Conversaciones con memoria', 'WhatsApp, Instagram y Facebook aterrizan en un inbox conectado al historial del cliente.'],
      ['Regreso provocado', 'Activa seguimientos y campañas para retoques, tratamientos y fechas especiales.'],
    ],
    proofPrompt: 'salones y spas',
    proofMetrics: ['Ocupación por especialista', 'Cancelaciones recuperadas', 'Clientes que regresan'],
  },
  {
    ...common,
    id: 'health',
    label: 'Salud',
    shortLabel: 'Salud',
    icon: HeartPulse,
    theme: { accent: '#0EA5A4', accent2: '#67E8F9', ink: '#073B3A', surface: '#ECFEFF', glow: '#CFFAFE' },
    eyebrow: 'Para consultorios, clínicas y centros de bienestar',
    problem: 'Un paciente potencial pregunta por horarios, nadie responde a tiempo y termina agendando con otra clínica.',
    agitation: 'La recepción salta entre teléfono, WhatsApp y redes mientras intenta confirmar citas. Cada conversación sin seguimiento enfría la confianza antes de la consulta.',
    solution: 'CavernicolApp centraliza la atención comercial, organiza recursos y automatiza confirmaciones sin convertir el CRM en expediente clínico.',
    job: 'Dar una respuesta clara y coordinar la cita correcta sin saturar a recepción.',
    outcome: 'Una experiencia de atención consistente desde la primera pregunta.',
    alert: 'Valoración inicial · confirmada',
    resource: 'Consultorio 02 · 16:30',
    lead: 'Carlos solicita disponibilidad',
    nextAction: 'Responder y proponer horarios',
    benefits: [
      ['Recepción unificada', 'Concentra consultas de redes, mensajería y llamadas en una sola bandeja con contexto.'],
      ['Agenda por recurso', 'Ordena profesionales, consultorios y servicios sin duplicar horarios.'],
      ['Seguimiento responsable', 'Automatiza recordatorios y continuidad comercial con permisos y trazabilidad.'],
    ],
    proofPrompt: 'clínicas y consultorios',
    proofMetrics: ['Tiempo de primera respuesta', 'Citas confirmadas', 'Seguimientos atendidos'],
  },
  {
    ...common,
    id: 'fitness',
    label: 'Fitness',
    shortLabel: 'Fitness',
    icon: Dumbbell,
    theme: { accent: '#7C3AED', accent2: '#C4B5FD', ink: '#241048', surface: '#F5F3FF', glow: '#EDE9FE' },
    eyebrow: 'Para gimnasios, estudios y coaches',
    problem: 'La clase muestra actividad, pero los prospectos que pidieron una prueba gratis desaparecen entre mensajes y hojas de cálculo.',
    agitation: 'Si nadie sabe quién preguntó, quién asistió y quién necesita un empujón, el equipo vuelve a pagar publicidad para reemplazar oportunidades que ya tenía.',
    solution: 'CavernicolApp convierte cada consulta en un seguimiento visible, agenda sesiones y activa conversaciones que acercan al prospecto a su primera clase.',
    job: 'Transformar interés inicial en asistencia y asistencia en una relación constante.',
    outcome: 'Un proceso comercial que no se queda sin aire después del primer contacto.',
    alert: 'Clase funcional · 2 lugares',
    resource: 'Coach Leo · Sala Norte',
    lead: 'Sofía pidió clase de prueba',
    nextAction: 'Confirmar asistencia',
    benefits: [
      ['Pruebas bajo control', 'Sigue cada pase, visita y conversación desde un pipeline visible.'],
      ['Agenda activa', 'Coordina entrenadores, espacios y sesiones con confirmaciones oportunas.'],
      ['Comunidad que vuelve', 'Segmenta contactos y reactiva personas inactivas con mensajes relevantes.'],
    ],
    proofPrompt: 'gimnasios y estudios',
    proofMetrics: ['Pruebas agendadas', 'Asistencias confirmadas', 'Prospectos reactivados'],
  },
  {
    ...common,
    id: 'education',
    label: 'Educación',
    shortLabel: 'Educación',
    icon: GraduationCap,
    theme: { accent: '#2563EB', accent2: '#93C5FD', ink: '#0B244A', surface: '#EFF6FF', glow: '#DBEAFE' },
    eyebrow: 'Para colegios, academias y centros de capacitación',
    problem: 'Una familia pide informes, recibe una respuesta genérica dos días después y la inscripción se va con la institución que sí dio seguimiento.',
    agitation: 'Admisiones reparte contactos por chat, llamadas y formularios sin una siguiente acción clara. Cuando llega el cierre, nadie sabe qué objeción quedó pendiente.',
    solution: 'CavernicolApp ordena aspirantes, recorridos, llamadas y seguimientos para que cada familia reciba información contextual y oportuna.',
    job: 'Acompañar a cada aspirante desde “quiero informes” hasta una decisión bien atendida.',
    outcome: 'Más claridad para admisiones y una experiencia cercana para cada familia.',
    alert: 'Recorrido de campus · confirmado',
    resource: 'Admisiones · 11:00',
    lead: 'Familia Ruiz pidió costos',
    nextAction: 'Enviar plan y agendar recorrido',
    benefits: [
      ['Admisiones visibles', 'Cada aspirante tiene etapa, responsable, historial y siguiente acción.'],
      ['Información consistente', 'La IA consulta la base autorizada para responder programas, horarios y requisitos.'],
      ['Seguimiento por ciclo', 'Crea segmentos y automatizaciones para recorridos, inscripciones y reinscripciones.'],
    ],
    proofPrompt: 'instituciones educativas',
    proofMetrics: ['Solicitudes atendidas', 'Recorridos agendados', 'Seguimientos completados'],
  },
  {
    ...common,
    id: 'automotive',
    label: 'Automotriz',
    shortLabel: 'Automotriz',
    icon: CarFront,
    theme: { accent: '#E11D48', accent2: '#FDA4AF', ink: '#3C101B', surface: '#FFF1F2', glow: '#FFE4E6' },
    eyebrow: 'Para agencias y distribuidores automotrices',
    problem: 'El lead preguntó por una SUV en Facebook, otro asesor lo contactó por WhatsApp y nadie sabe quién prometió la prueba de manejo.',
    agitation: 'Las oportunidades se duplican, se enfrían o se pelean. Mientras tanto, el comprador sigue viendo anuncios de la competencia y avanza con quien responde primero.',
    solution: 'CavernicolApp unifica origen, conversación, asignación y seguimiento para mover cada lead hacia llamada, cotización o prueba de manejo.',
    job: 'Responder en el primer minuto y coordinar al equipo hasta que el prospecto llegue a piso.',
    outcome: 'Una operación comercial donde ningún lead queda estacionado.',
    alert: 'Prueba de manejo · confirmada',
    resource: 'Tracker 2026 · Asesor Diego',
    lead: 'Luis preguntó por bono y mensualidad',
    nextAction: 'Compartir ficha y agendar',
    benefits: [
      ['Leads sin colisiones', 'Captura origen, deduplica contexto y asigna oportunidades con reglas claras.'],
      ['Catálogo en la conversación', 'Comparte modelos, fichas, fotos y enlaces desde el flujo de atención.'],
      ['Publicidad conectada', 'Gestiona campañas, públicos y anuncios de Meta con seguimiento hasta CRM.'],
    ],
    proofPrompt: 'agencias automotrices',
    proofMetrics: ['Tiempo de contacto', 'Pruebas de manejo', 'Leads por fuente'],
  },
  {
    ...common,
    id: 'real-estate',
    label: 'Inmobiliaria',
    shortLabel: 'Inmuebles',
    icon: House,
    theme: { accent: '#C48A2C', accent2: '#F4D38A', ink: '#3D2A0C', surface: '#FFFBEB', glow: '#FEF3C7' },
    eyebrow: 'Para desarrolladores, inmobiliarias y brokers',
    problem: 'Un comprador pregunta por una tipología específica, recibe el brochure equivocado y deja de contestar.',
    agitation: 'Los leads llegan de portales, campañas y referidos con presupuestos distintos. Sin contexto ni inventario comercial organizado, cada asesor improvisa la experiencia.',
    solution: 'CavernicolApp conecta desarrollos, fuentes, conversaciones y pipeline para perfilar, compartir el material correcto y agendar la visita.',
    job: 'Relacionar a cada comprador con la propiedad adecuada antes de que pierda interés.',
    outcome: 'Seguimientos más relevantes y visitas con mejor contexto comercial.',
    alert: 'Visita a desarrollo · confirmada',
    resource: 'Torre B · Tipo Garden',
    lead: 'Ana busca 2 recámaras y terraza',
    nextAction: 'Enviar disponibilidad y recorrido',
    benefits: [
      ['Perfil antes del brochure', 'Registra presupuesto, zona, tipología y urgencia para orientar la conversación.'],
      ['Desarrollos organizados', 'Centraliza proyectos, ubicaciones, materiales y responsables comerciales.'],
      ['Fuentes que sí se comparan', 'Conecta campañas y lead sources con pipeline y resultados por origen.'],
    ],
    proofPrompt: 'desarrolladores e inmobiliarias',
    proofMetrics: ['Leads perfilados', 'Visitas agendadas', 'Conversión por desarrollo'],
  },
  {
    ...common,
    id: 'professional',
    label: 'Servicios profesionales',
    shortLabel: 'Servicios',
    icon: BriefcaseBusiness,
    theme: { accent: '#334155', accent2: '#94A3B8', ink: '#0F172A', surface: '#F8FAFC', glow: '#E2E8F0' },
    eyebrow: 'Para despachos, consultoras y servicios B2B',
    problem: 'La propuesta salió, el cliente dijo “lo reviso” y la oportunidad quedó enterrada debajo de otros veinte correos.',
    agitation: 'Cuando el seguimiento vive en la agenda personal del ejecutivo, la dirección ve el retraso hasta que el negocio ya se perdió.',
    solution: 'CavernicolApp convierte conversaciones, reuniones y compromisos en un pipeline compartido con automatizaciones y tareas visibles.',
    job: 'Mantener cada oportunidad avanzando sin depender de recordatorios mentales.',
    outcome: 'Más control del ciclo comercial y menos “pensé que tú le hablarías”.',
    alert: 'Revisión de propuesta · hoy',
    resource: 'Consultor asignado · M. Ríos',
    lead: 'Grupo Norte abrió la propuesta',
    nextAction: 'Agendar revisión ejecutiva',
    benefits: [
      ['Pipeline consultivo', 'Define etapas, responsables, SLA y acciones para ciclos de venta largos.'],
      ['Conocimiento disponible', 'Entrena la IA con servicios, procesos y documentos autorizados del despacho.'],
      ['Dirección con contexto', 'Consulta actividad, embudo y atención sin perseguir reportes manuales.'],
    ],
    proofPrompt: 'despachos y consultoras',
    proofMetrics: ['Propuestas con seguimiento', 'Tiempo por etapa', 'Oportunidades activas'],
  },
  {
    ...common,
    id: 'other',
    label: 'Otros negocios',
    shortLabel: 'Otros',
    icon: Store,
    theme: { accent: '#F72585', accent2: '#FB7185', ink: '#2B1020', surface: '#FFF5F8', glow: '#FCE7F3' },
    eyebrow: 'Para operaciones comerciales que no caben en una plantilla',
    problem: 'Tu negocio ya vende, pero clientes, mensajes, tareas y campañas viven en herramientas separadas que no se hablan.',
    agitation: 'Cada cambio de pantalla rompe el contexto. El equipo captura dos veces, olvida seguimientos y termina trabajando para el software en lugar de usarlo.',
    solution: 'CavernicolApp configura módulos, roles, pipeline, agenda e IA alrededor de tu operación real y crece por capas contigo.',
    job: 'Tener una fuente única de verdad sin adaptar el negocio a un CRM rígido.',
    outcome: 'Una operación conectada que puede evolucionar sin volver a empezar.',
    alert: 'Nueva oportunidad · asignada',
    resource: 'Equipo comercial · En línea',
    lead: 'Cliente solicita información',
    nextAction: 'Calificar y dar seguimiento',
    benefits: [
      ['Arquitectura modular', 'Activa CRM, agenda, marketing, IA, catálogo y administración por etapas.'],
      ['Tu proceso, tus términos', 'Personaliza pipeline, roles, sedes y automatizaciones por negocio.'],
      ['Canales conectados', 'Reúne conversaciones, campañas y datos del cliente en una misma operación.'],
    ],
    proofPrompt: 'negocios como el tuyo',
    proofMetrics: ['Atenciones centralizadas', 'Tareas automatizadas', 'Oportunidades visibles'],
  },
  {
    ...common,
    id: 'workshop',
    label: 'Talleres mecánicos',
    shortLabel: 'Talleres',
    icon: Wrench,
    theme: { accent: '#F97316', accent2: '#FDBA74', ink: '#431407', surface: '#FFF7ED', glow: '#FFEDD5' },
    eyebrow: 'Para talleres, centros de servicio y detallado',
    problem: 'El cliente dejó su auto, pidió una actualización por WhatsApp y nadie sabe si ya autorizaron los frenos o si la unidad sigue esperando diagnóstico.',
    agitation: 'Entre llamadas, notas y fotos sueltas, el asesor repite preguntas, el técnico espera y el cliente siente que su vehículo cayó en un agujero negro.',
    solution: 'CavernicolApp configura el flujo de servicio en CRM, centraliza conversaciones y agenda recursos para que cada unidad tenga responsable y siguiente paso.',
    job: 'Dar visibilidad al cliente y mover cada vehículo sin perder autorizaciones ni contexto.',
    outcome: 'Más orden en piso y menos llamadas de “¿cómo va mi coche?”.',
    alert: 'Vehículo en rampa 2',
    resource: 'Mazda 3 · Cambio de frenos',
    lead: 'Autorización recibida por WhatsApp',
    nextAction: 'Asignar técnico y actualizar etapa',
    benefits: [
      ['Flujo por vehículo', 'Configura diagnóstico, autorización, servicio, control y entrega como etapas visibles.'],
      ['Cliente informado', 'Conserva mensajes, acuerdos y archivos en la conversación relacionada.'],
      ['Recursos coordinados', 'Agenda rampas, técnicos y entregas para reducir cuellos de botella.'],
    ],
    proofPrompt: 'talleres y centros de servicio',
    proofMetrics: ['Órdenes con siguiente paso', 'Autorizaciones registradas', 'Entregas coordinadas'],
  },
  {
    ...common,
    id: 'hotel',
    label: 'Hoteles',
    shortLabel: 'Hoteles',
    icon: Hotel,
    theme: { accent: '#0F766E', accent2: '#5EEAD4', ink: '#063A36', surface: '#F0FDFA', glow: '#CCFBF1' },
    eyebrow: 'Para hoteles boutique, resorts y grupos de hospitalidad',
    problem: 'Una pareja pregunta por disponibilidad, traslado y cena romántica en tres canales distintos; el equipo responde cada mensaje como si fuera un huésped diferente.',
    agitation: 'La reserva puede vivir en el PMS, pero la relación se fragmenta antes y después de la estancia. Ahí se pierden extras, preferencias y la oportunidad de volver.',
    solution: 'CavernicolApp complementa tu operación hotelera con CRM, inbox, campañas y automatizaciones para unificar la relación comercial con el huésped.',
    job: 'Reconocer al huésped en cada canal y coordinar una experiencia relevante alrededor de su estancia.',
    outcome: 'Más continuidad entre consulta, estancia y próxima visita, sin pretender reemplazar tu PMS.',
    alert: 'Solicitud de huésped · confirmada',
    resource: 'Suite Jardín · aniversario',
    lead: 'Traslado y cena agregados',
    nextAction: 'Confirmar experiencia por WhatsApp',
    benefits: [
      ['Perfil de huésped conectado', 'Reúne conversaciones, preferencias comerciales y actividad en un solo historial.'],
      ['Experiencias coordinadas', 'Agenda traslados, spa, restaurante y seguimiento como recursos configurables.'],
      ['Relación después del checkout', 'Segmenta huéspedes y activa campañas de regreso con contexto.'],
    ],
    proofPrompt: 'hoteles y resorts',
    proofMetrics: ['Consultas atendidas', 'Experiencias adicionales', 'Huéspedes reactivados'],
  },
  {
    ...common,
    id: 'restaurant',
    label: 'Restaurantes',
    shortLabel: 'Restaurantes',
    icon: Utensils,
    theme: { accent: '#DC2626', accent2: '#FCA5A5', ink: '#450A0A', surface: '#FEF2F2', glow: '#FEE2E2' },
    eyebrow: 'Para restaurantes, grupos y conceptos gastronómicos',
    problem: 'La Mesa 4 quedó libre mientras una solicitud de reservación esperaba respuesta en Instagram.',
    agitation: 'El equipo atiende el salón, el teléfono y los DMs al mismo tiempo. Sin un historial común, cumpleaños, preferencias y clientes frecuentes vuelven a empezar desde cero.',
    solution: 'CavernicolApp centraliza solicitudes, agenda mesas o experiencias y activa campañas para convertir una buena visita en la siguiente.',
    job: 'Llenar mesas con una atención ágil y reconocer a quien ya eligió el restaurante antes.',
    outcome: 'Más continuidad entre la reservación, la experiencia y el regreso.',
    alert: 'Mesa 4 · reservada',
    resource: '4 personas · terraza · 20:30',
    lead: 'Celebración de cumpleaños',
    nextAction: 'Confirmar y registrar preferencia',
    benefits: [
      ['Reservaciones centralizadas', 'Convierte mensajes y llamadas en espacios confirmados con responsable.'],
      ['Clientes reconocibles', 'Guarda historial, preferencias y ocasiones para personalizar la atención.'],
      ['Demanda activada', 'Segmenta y comunica menús, eventos y horarios de baja ocupación.'],
    ],
    proofPrompt: 'restaurantes',
    proofMetrics: ['Reservaciones confirmadas', 'Clientes recurrentes', 'Campañas de regreso'],
  },
];

export const CAPABILITY_PILLS = [
  'CRM y pipeline',
  'Agenda por recursos',
  'Inbox multicanal',
  'Agentes de IA',
  'Marketing Automation',
  'Social Studio + Meta Ads',
  'Catálogo y POS',
  'Reportes y multi-sede',
];

// Sprint 73.2 — fuente única de verdad de los textos compartidos por
// defecto, usada tanto por LandingPage.js (fallback de contenido) como por
// LandingConfig.js (placeholder "marca de agua" en el editor de copys).
export const DEFAULT_SHARED_CONTENT = {
  hero_badge: 'CRM + CEM + IA, adaptado a tu operación',
  hero_title_static: 'Todas tus conversaciones.',
  hero_title_emphasis: 'Una sola inteligencia para vender mejor.',
  hero_trust_1: 'Modular',
  hero_trust_2: 'Multi-tenant',
  hero_trust_3: 'Hecho para operar en México',
  beneficios_kicker: 'BENEFICIOS QUE CAMBIAN CON TU INDUSTRIA',
  beneficios_heading_static: 'La misma plataforma.',
  beneficios_heading_emphasis: 'El flujo que tu {{vertical}} reconoce.',
  producto_kicker: 'UN CEREBRO, MÚLTIPLES MÓDULOS',
  producto_heading_static: 'Conecta la operación.',
  producto_heading_emphasis: 'Activa sólo lo que necesitas.',
  producto_copy: 'CavernicolApp crece por capas: comienza con atención, CRM y agenda; incorpora IA, marketing, redes, anuncios, catálogo, POS y administración cuando tu operación lo pida.',
  evidencia_kicker: 'CONFIANZA SIN CAMBIO DE DISFRAZ',
  how_kicker: 'DE LA PREHISTORIA AL FLUJO',
  how_heading_static: 'Tres pasos.',
  how_heading_emphasis: 'Cero expediciones entre pestañas.',
  how_step1_title: 'Describe tu operación',
  how_step1_desc: 'Vertical, sedes, equipo, canales y el proceso que hoy ya existe.',
  how_step2_title: 'Activa tus módulos',
  how_step2_desc: 'Configura CRM, agenda, conversaciones, IA y automatizaciones por etapas.',
  how_step3_title: 'Haz que el sistema trabaje',
  how_step3_desc: 'Cada interacción conserva contexto y dispara la siguiente mejor acción.',
  final_heading_static: 'Tu siguiente cliente ya está hablando.',
  final_heading_emphasis: 'Haz que tu operación escuche.',
  capability_pills_csv: CAPABILITY_PILLS.join(', '),
};

// Aplana un objeto de VERTICALS al esquema plano que usa el editor de copys
// de Super Admin (benefit{n}_title/desc, proofMetric{n}) — misma forma que
// mergeVerticalContent() de LandingPage.js reconstruye a la inversa.
export function flattenVerticalDefaults(vertical) {
  if (!vertical) return {};
  const benefits = vertical.benefits || [];
  const proofMetrics = vertical.proofMetrics || [];
  const flat = {
    label: vertical.label, shortLabel: vertical.shortLabel, eyebrow: vertical.eyebrow,
    problem: vertical.problem, agitation: vertical.agitation, solution: vertical.solution,
    job: vertical.job, outcome: vertical.outcome, alert: vertical.alert, resource: vertical.resource,
    lead: vertical.lead, nextAction: vertical.nextAction, proofPrompt: vertical.proofPrompt,
  };
  benefits.forEach(([title, desc], i) => {
    flat[`benefit${i + 1}_title`] = title;
    flat[`benefit${i + 1}_desc`] = desc;
  });
  proofMetrics.forEach((metric, i) => {
    flat[`proofMetric${i + 1}`] = metric;
  });
  return flat;
}
